import { TransButtons } from "./TransButtons";

/**
 * 中英并排输入（单行或多行）+ 中间双向翻译按钮。
 * 复用 admin globals.css 的 .ce-bilingual / .ce-bi-col / .ce-bi-mid / .ce-bi-tag。
 * （NewsEditorPage 有一份局部同名实现，历史原因未合并；新代码统一用本组件。）
 */
export function BiField({ label, cn, en, onCn, onEn, rows, placeholder }: {
  label?: string;
  cn: string;
  en: string;
  onCn: (v: string) => void;
  onEn: (v: string) => void;
  rows?: number;
  placeholder?: string;
}) {
  return (
    <div className="ce-field">
      {label && <div className="ce-label">{label}</div>}
      <div className={`ce-bilingual${rows ? "" : " ce-bilingual--single"}`}>
        <div className="ce-bi-col">
          <span className="ce-bi-tag">中</span>
          {rows
            ? <textarea className="ce-input" rows={rows} value={cn} placeholder={placeholder} onChange={(e) => onCn(e.target.value)} />
            : <input className="ce-input" value={cn} placeholder={placeholder} onChange={(e) => onCn(e.target.value)} />}
        </div>
        <div className="ce-bi-mid">
          <TransButtons getCn={() => cn} getEn={() => en} setCn={onCn} setEn={onEn} title={label} />
        </div>
        <div className="ce-bi-col">
          <span className="ce-bi-tag">EN</span>
          {rows
            ? <textarea className="ce-input" rows={rows} value={en} onChange={(e) => onEn(e.target.value)} />
            : <input className="ce-input" value={en} onChange={(e) => onEn(e.target.value)} />}
        </div>
      </div>
    </div>
  );
}
